import request from '../../../../api/request';
import { downloadFromBlob } from '../../../../utils/blob';
import {
  ChargeItem,
  CreateChargeBody,
  DebtFiltersState,
  DebtResponse,
} from '../Debt/types';

const CURRENT_ACCOUNT = {
  DEBTS: (studentId: string | number) =>
    `maintainers-portal/financial-portal/current-account/students/${studentId}/debts`,

  DOWNLOAD_VOUCHER: (studentId: string | number) =>
    `maintainers-portal/financial-portal/current-account/students/${studentId}/debts/download-voucher`,

  CHARGE_ITEMS:
    'maintainers-portal/financial-portal/current-account/charges/items',

  CREATE_CHARGE: (studentId: string | number) =>
    `maintainers-portal/financial-portal/current-account/students/${studentId}/charges`,
};

// HU #15319 — serialize only the dimensions that are not null, so the query
// string stays clean (`?year=2026&period=1`) and the backend DTO's optional
// decorators can treat missing fields as "no filter".
function toDebtsQueryParams(
  filters?: DebtFiltersState | null,
): Record<string, string | number> | undefined {
  if (!filters) {
    return undefined;
  }
  const params: Record<string, string | number> = {};
  if (filters.year !== null) {
    params.year = filters.year;
  }
  if (filters.period !== null) {
    params.period = filters.period;
  }
  if (filters.studyPlanId !== null) {
    params.studyPlanId = filters.studyPlanId;
  }
  if (filters.status !== null) {
    params.status = filters.status;
  }
  return Object.keys(params).length > 0 ? params : undefined;
}

export function getDebts(
  studentId: string | number,
  filters?: DebtFiltersState | null,
) {
  const params = toDebtsQueryParams(filters);
  return request<DebtResponse>(CURRENT_ACCOUNT.DEBTS(studentId), {
    method: 'get',
    ...(params ? { params } : {}),
  });
}

export async function downloadVoucher({
  studentId,
  debtIds,
  amountToPay,
}: {
  studentId: string | number;
  debtIds: number[];
  amountToPay: number;
}) {
  const res = await request(CURRENT_ACCOUNT.DOWNLOAD_VOUCHER(studentId), {
    method: 'POST',
    data: { debtIds, amountToPay },
    responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'application/pdf' });
  downloadFromBlob(blob, 'voucher.pdf');
}

export function getChargeItems() {
  return request<ChargeItem[]>(CURRENT_ACCOUNT.CHARGE_ITEMS, {
    method: 'get',
  });
}

export function createCharge(studentId: number, body: CreateChargeBody) {
  return request<{ paymentAgreementId: string; debtId: string }>(
    CURRENT_ACCOUNT.CREATE_CHARGE(studentId),
    { method: 'POST', data: body },
  );
}
